export default __webpack_public_path__ + "static/media/icon-256x256.892b85b3.png";